exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.personal-inquiry-page {\n  padding-top: 52px;\n}\n.personal-inquiry-page .input-group {\n    width: 49%;\n}\n.personal-inquiry-page .input-group .input {\n      width: 360px;\n}\n.personal-inquiry-page .input-group.has-radio .input {\n      width: 240px;\n}\n.personal-inquiry-page .input-group .address {\n      width: 360px;\n}\n.personal-inquiry-page .inquiry-btn {\n    display: block;\n    width: 364px;\n    height: 48px;\n    line-height: 48px;\n    text-align: center;\n    margin: 0 auto;\n    margin-top: 40px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c1a1e5dc","scoped":false,"hasInlineConfig":false}!./node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/views/personal/inquiry.vue
// module id = 98BC
// module chunks = 1